import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import styled from 'styled-components';

import logo from '../assets/icons/logo_mini.svg';

export default function CategoryHeader({ categoryHeaderData, category }) {
	return (
		<Row className='category-header'>
			<Col className='category-header__left-container'>
				<Row>
					<Col className='category-header__title-container'>
						<span className='category-header__title'>
							{categoryHeaderData[category]?.title}
						</span>
					</Col>
				</Row>
				<Row>
					<Col className='category-header__description-container'>
						<span className='category-header__description'>
							{categoryHeaderData[category]?.description}
						</span>
					</Col>
				</Row>
			</Col>
			<Col className='category-header__right-container'>
				<Row className='category-header__benefit-container'>
					<Row>
						<Col className='category-header__benefit-title-container'>
							<div className='category-header__benefit-logo-container'>
								<img src={logo} alt='konnect new logo' />
							</div>
							<span className='category-header__benefit-title'>
								{categoryHeaderData['Benefits'].title}
							</span>
						</Col>
					</Row>
					<Row className='benefit_content_m'>
						<Col className='category-header__benefit-content-container'>
							{categoryHeaderData[category].benefit?.map(
								(item, index) => {
									return (
										<Row key={index}>
											<Col>
												<span className='category-header__benefit'>
													{item}
												</span>
											</Col>
										</Row>
									);
								}
							)}
						</Col>
					</Row>
				</Row>
			</Col>
		</Row>
	);
}
